import { User } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";

const grantAdminRole = async (email: string) => {
  const functions = getFunctions();
  const addAdminRole = httpsCallable(functions, "addAdminRole");

  try {
    const result = await addAdminRole({ email });
    const data = result.data as { message: string };
    console.log(`${data.message}`);
    return { success: true, message: data.message };
  } catch (error: any) {
    console.error("Error granting admin role:", error);
    return { success: false, message: error.message || "Failed to grant admin role" };
  }
};

const revokeAdminRole = async (email: string) => {
  const functions = getFunctions();
  const revokeAdmin = httpsCallable(functions, "revokeAdminRole");

  try {
    const result = await revokeAdmin({ email });
    const data = result.data as { message: string };
    console.log(`${data.message}`);
    return { success: true, message: data.message };
  } catch (error: any) {
    console.error("Error revoking admin role:", error);
    return { success: false, message: error.message || "Failed to revoke admin role" };
  }
};

// CLIENT SIDE checker if current user is admin and returns boolean value on client
const checkAdminClient = async (user: User | null) => {

  if (!user) {
    return false;
  }

  try {
    // Force token refresh to get latest custom claims
    const idTokenResult = await user.getIdTokenResult(true); // true forces refresh
    // console.log("ID Token Claims:", idTokenResult.claims);
    
    if (idTokenResult.claims.admin) {
      // console.log("User has admin privileges.");
      return true;
    } else {
      // console.log("User does NOT have admin privileges.");
      // console.log("If you just set admin, please sign out and sign back in.");
      return false;
    }
  } catch (error) {
    // console.error("Error checking admin privileges: ", error);
    return false;
  }
}

export { grantAdminRole, revokeAdminRole, checkAdminClient };

